import { useMemo } from 'react';
import { getTimezones, type ITimezone } from '@moko/utils';
import { SearchableDropdown } from '../SearchableDropdown';
import useFetch from '../hooks/useFetch';

export type TimezoneSelectProps = {
  value?: string;
  onChange: (timezoneId: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

export const TimezoneSelect = ({
  value,
  onChange,
  placeholder,
  disabled,
  className,
}: TimezoneSelectProps) => {
  const { data, loading } = useFetch<ITimezone[]>({
    queryKey: ['timezones'],
    queryFn: getTimezones,
  });
  const options = useMemo(
    () =>
      (data ?? []).map((timezone) => ({
        key: timezone.name,
        label: timezone.name,
      })),
    [data]
  );

  return (
    <SearchableDropdown
      options={options}
      value={value}
      valueLabel={value}
      placeholder={placeholder}
      disabled={disabled || loading}
      className={className}
      onSelect={onChange}
    />
  );
};
